import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import PraticaEffect from "./PraticaEffect";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import PraticaInfoPraticaRequestModel from "./models/PraticaInfoPraticaRequestModel";

type ActionUnion = undefined | HttpErrorResponseModel | ResponseEsitoModel | PraticaInfoPraticaRequestModel;

export default class PraticaAction {
    public static readonly REQUEST_CREA_PRATICA_CQSOL: string = "RichiestaAction.REQUEST_CREA_PRATICA_CQSOL";
    public static readonly REQUEST_CREA_PRATICA_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_CREA_PRATICA_CQSOL_FINISHED";

    public static readonly REQUEST_INFO_PRATICA_CQSOL: string = "RichiestaAction.REQUEST_INFO_PRATICA_CQSOL";
    public static readonly REQUEST_INFO_PRATICA_CQSOL_FINISHED: string =
        "RichiestaAction.REQUEST_INFO_PRATICA_CQSOL_FINISHED";

    public static readonly REQUEST_ERROR: string = "RichiestaAction.REQUEST_ERROR";
    public static readonly REQUEST_ERROR_FINISHED: string = "RichiestaAction.REQUEST_ERROR_FINISHED";

    public static requestCreaPraticaCqsOnline(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                PraticaAction.REQUEST_CREA_PRATICA_CQSOL,
                PraticaEffect.requestCreaPraticaCqsOnline,
                idPreventivo
            );
        };
    }

    public static requestGetInfoPratica(idPreventivo: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<PraticaInfoPraticaRequestModel>(
                dispatch,
                PraticaAction.REQUEST_INFO_PRATICA_CQSOL,
                PraticaEffect.requestGetInfoPratica,
                idPreventivo
            );
        };
    }

    public static requestError(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<any>(
                dispatch,
                PraticaAction.REQUEST_ERROR,
                PraticaEffect.requestError
            );
        };
    }
}
